import L, { get, latLngBounds, openOn, zoomOntoMarker, latLng } from "leaflet";
import { GestureHandling } from "leaflet-gesture-handling";
import { useEffect, useState } from "react";
import { useMap } from "react-leaflet";
import { sortByDistance } from "./sortByDistance";

function ChangeView({
  center,
  zoom,
  markers,
  selectedInstitution,
  data,
  customMarkerRefs,
  mapRef,
  setMapRef,
  clusterRef,
  popupRefs,
  sizeState,
  userCurrentPosition,
  selectedGeoAdress,
  setFilteredEntities,
}) {
  const map = useMap();
  const [currentPopup, setCurrentPopup] = useState();
  const [sortedEntities, setSortedEntities] = useState(null);

  // const mapReff = map;

  //--- Add google map gesture handling
  map.gestureHandling.enable();

  //--- Change map bounds when the marker list change to fit the displayed markers onto the map
  const [bounds, setBounds] = useState(() => {
    let markerBounds = latLngBounds([]);
    if (markers.length && markers.length > 0 && !selectedInstitution) {
      markers.forEach((marker) => {
        if (marker != null) {
          //--- with custom markers component
          markerBounds.extend([
            marker.props.entity.latitude,
            marker.props.entity.longitude,
          ]);
        }
      });
    }
    return markerBounds;
  });

  let markerBounds = latLngBounds([]);

  useEffect(() => {
    setMapRef(map);
  }, [map]);

  useEffect(() => {
    if (markers.length && markers.length > 0 && !selectedInstitution) {
      markers.forEach((marker) => {
        if (marker != null) {
          //--- with custom markers component
          markerBounds.extend([
            marker.props.entity.latitude,
            marker.props.entity.longitude,
          ]);
        }
      });
      if (!selectedGeoAdress) {
        map.fitBounds(markerBounds, { maxZoom: changeZoom() });
        setBounds(markerBounds);
      }
    }
  }, [data, selectedInstitution, sizeState, selectedGeoAdress]);

  useEffect(() => {
    if (selectedGeoAdress) {
      // console.log("ici", selectedGeoAdress);

      const addressLtnLgn = L.latLng(
        parseFloat(selectedGeoAdress.geometry.coordinates[1]),
        parseFloat(selectedGeoAdress.geometry.coordinates[0])
      );

      const sortedEntitiesByDistance = sortByDistance(selectedGeoAdress, data);

      setSortedEntities(() => sortedEntitiesByDistance);

      if (selectedGeoAdress.properties.type === "departement") {
        // map.setZoom(10);
        map.flyTo(addressLtnLgn, 9);
      } else if (selectedGeoAdress.properties.type === "region") {
        map.flyTo(addressLtnLgn, 8.5);
      } else {
        map.fitBounds(
          [
            [
              sortedEntitiesByDistance[0].latitude,
              sortedEntitiesByDistance[0].longitude,
            ],
            [
              selectedGeoAdress.geometry.coordinates[1],
              selectedGeoAdress.geometry.coordinates[0],
            ],
          ],
          {
            maxZoom: 11,
            padding: [50, 50],
          }
        );
      }

      // console.log("sorted", sortedEntities);
    }
  }, [selectedGeoAdress]);

  useEffect(() => {
    if (sortedEntities) {
      setFilteredEntities(sortedEntities);
    }
  }, [sortedEntities]);

  const closePopup = () => {
    if (process.env.REACT_APP_POPUP) {
      if (currentPopup) {
        map.closePopup(currentPopup);
        setCurrentPopup(null);
      }
    }
  };

  const delay = (n) => {
    n = n || 2000;
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve();
      }, n);
    });
  };

  async function zoomSmoothly(cluster = null, marker = null, popup) {
    if (cluster && marker) {
      await cluster.zoomToShowLayer(marker);
      await delay(300);
    }
    if (popup) {
      await map.openPopup(popup);
    }
  }

  const changeZoom = () => {
    if (
      process.env.REACT_APP__DEFAULT_MAXZOOM &&
      typeof Number(process.env.REACT_APP__DEFAULT_MAXZOOM) === "number"
    ) {
      return Number(process.env.REACT_APP__DEFAULT_MAXZOOM);
    } else {
      return null;
    }
  };

  const zoomOntoMarker = () => {
    if (process.env.REACT_APP_POPUP) {
      if (selectedInstitution) {
        customMarkerRefs.current.forEach((markerRef, i) => {
          const marker = markerRef.current;
          const cluster = clusterRef.current;
          if (marker) {
            const popup = marker._popup;
            if (marker.options.calc.id === selectedInstitution.id) {
              const parentElement = cluster.getVisibleParent(marker);
              if (parentElement) {
                if (
                  !parentElement._preSpiderfyLatlng &&
                  parentElement._childCount
                ) {
                  zoomSmoothly(cluster, marker, popup);
                } else {
                  setCurrentPopup(popup);
                  zoomSmoothly(null, null, popup);
                }
              } else {
                setCurrentPopup(popup);
                zoomSmoothly(null, null, popup);
              }
            }
          }
        });
      }
    } else if (
      !process.env.REACT_APP_POPUP &&
      process.env.REACT_APP_CLUSTER > 0
    ) {
      if (selectedInstitution) {
        customMarkerRefs.current.forEach((markerRef, i) => {
          const marker = markerRef.current;
          const cluster = clusterRef.current;
          if (marker) {
            if (marker.options.calc.id === selectedInstitution.id) {
              const parentElement = cluster.getVisibleParent(marker);
              if (parentElement) {
                if (
                  !parentElement._preSpiderfyLatlng &&
                  parentElement._childCount
                ) {
                  zoomSmoothly(cluster, marker, "");
                }
              }
            }
          }
        });
      }
    }
  };

  //--- Add offset (popup Info width) to the map bounds when an entity is selected so the corresponding marker is centered
  useEffect(() => {
    closePopup();
    let timer = false;
    if (selectedInstitution) {
      if (window.innerWidth > 992) {
        let markerPosition = map.latLngToContainerPoint([
          parseFloat(selectedInstitution.latitude),
          parseFloat(selectedInstitution.longitude),
        ]);
        const offset =
          process.env.REACT_APP_INSTITUTIONLAYER === "true" ? 215 : 0;
        if (process.env.REACT_APP_SIDEBAR === "right") {
          let newPosition = L.point([
            markerPosition.x + offset,
            markerPosition.y,
          ]);
          let newLatLng = map.containerPointToLatLng(newPosition);
          map.setView(newLatLng, map.getZoom());
          timer = setTimeout(() => {
            zoomOntoMarker();
          }, 500);
        } else {
          let newPosition = L.point([
            markerPosition.x - offset,
            markerPosition.y,
          ]);
          let newLatLng = map.containerPointToLatLng(newPosition);
          map.setView(newLatLng, map.getZoom());
          timer = setTimeout(() => {
            zoomOntoMarker();
          }, 500);
        }
      } else {
        let markerPosition = map.latLngToContainerPoint([
          parseFloat(selectedInstitution.latitude),
          parseFloat(selectedInstitution.longitude),
        ]);
        let newPosition = L.point([
          markerPosition.x,
          markerPosition.y + 270 / 2,
        ]);
        let newLatLng = map.containerPointToLatLng(newPosition);
        map.setView(newLatLng, map.getZoom());
        timer = setTimeout(() => {
          zoomOntoMarker();
        }, 500);
      }
    } else {
      // map.fitBounds(bounds);
      // unZoom();
    }
    return () => {
      clearTimeout(timer);
    };
  }, [selectedInstitution]);

  return null;
}

export default ChangeView;
